module.exports = __webpack_public_path__ + "img/4_54.c4e0e027.png";